import { useAction } from "@/hooks/shared";
import { cancelInvitationHandler } from "@/services";

export const useCancelInvitation = () => useAction(cancelInvitationHandler);
